import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import RetailOrderPostInstallGrid from '../../../features/cfi/retail-order/components/RetailOrderPostInstallGrid';

export default function RetailOrderPostInstallPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Post-Install Calls')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<RetailOrderPostInstallGrid />
			</div>
		</React.Fragment>
	)
} 
